
export const ReportPresaVisioneListInputs = (optionAziende: any[]) => ([
    {
        label: 'Azienda',
        name: 'aziendaId',
        placeholder: 'Azienda',
        type: 'text',
        validators: { required: 'Il campo è richiesto' },
        type_input: 'react-select',
        size_input: 'w-full',
        isLimitDate: false,
        isTimeShow: false,
        options:  optionAziende?.map((el: any) => ({value: el.id, label: el.nome})) || []
    }
]);


export const CatInputs = (optionCategoria: any[]) => (
    [
        {
            label: 'Categoria',
            name: 'categoriaId',
            placeholder: 'Categoria',
            type: 'text',
            validators: {},
            type_input: 'react-select',
            size_input: 'w-full',
            isLimitDate: false,
            isTimeShow: false,
            options: optionCategoria?.map((el) => ({value: el.id, label: el.nome})) || []
        }
    ]
) 